// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

// This was generated using spacetimedb cli version 2.0.1 (commit a4d29daec8ed35ce4913a335b7210b9ae3933d00).

/* eslint-disable */
/* tslint:disable */
import {
  DbConnectionBuilder as __DbConnectionBuilder,
  DbConnectionImpl as __DbConnectionImpl,
  SubscriptionBuilderImpl as __SubscriptionBuilderImpl,
  TypeBuilder as __TypeBuilder,
  Uuid as __Uuid,
  convertToAccessorMap as __convertToAccessorMap,
  makeQueryBuilder as __makeQueryBuilder,
  procedureSchema as __procedureSchema,
  procedures as __procedures,
  reducerSchema as __reducerSchema,
  reducers as __reducers,
  schema as __schema,
  t as __t,
  table as __table,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type DbConnectionConfig as __DbConnectionConfig,
  type ErrorContextInterface as __ErrorContextInterface,
  type Event as __Event,
  type EventContextInterface as __EventContextInterface,
  type Infer as __Infer,
  type QueryBuilder as __QueryBuilder,
  type ReducerEventContextInterface as __ReducerEventContextInterface,
  type RemoteModule as __RemoteModule,
  type SubscriptionEventContextInterface as __SubscriptionEventContextInterface,
  type SubscriptionHandleImpl as __SubscriptionHandleImpl,
} from "spacetimedb";

// Import all reducer arg schemas
import AddAttachmentReducer from "./add_attachment_reducer";
import AddGroupMemberReducer from "./add_group_member_reducer";
import AddReactionReducer from "./add_reaction_reducer";
import ArchiveConversationReducer from "./archive_conversation_reducer";
import CheckEmailExistsReducer from "./check_email_exists_reducer";
import CreateDirectConversationReducer from "./create_direct_conversation_reducer";
import CreateGroupConversationReducer from "./create_group_conversation_reducer";
import CreateNotificationReducer from "./create_notification_reducer";
import DeleteMessageReducer from "./delete_message_reducer";
import DeleteNotificationReducer from "./delete_notification_reducer";
import DemoteFromAdminReducer from "./demote_from_admin_reducer";
import EditMessageReducer from "./edit_message_reducer";
import LeaveConversationReducer from "./leave_conversation_reducer";
import LoginWithEmailReducer from "./login_with_email_reducer";
import MarkAllNotificationsReadReducer from "./mark_all_notifications_read_reducer";
import MarkAsReadReducer from "./mark_as_read_reducer";
import MarkNotificationReadReducer from "./mark_notification_read_reducer";
import MuteConversationReducer from "./mute_conversation_reducer";
import PinMessageReducer from "./pin_message_reducer";
import PromoteToAdminReducer from "./promote_to_admin_reducer";
import RegisterUserReducer from "./register_user_reducer";
import RemoveGroupMemberReducer from "./remove_group_member_reducer";
import RemoveReactionReducer from "./remove_reaction_reducer";
import RequestEmailVerificationReducer from "./request_email_verification_reducer";
import SendMessageReducer from "./send_message_reducer";
import SendMessageWithAttachmentReducer from "./send_message_with_attachment_reducer";
import SetPresenceReducer from "./set_presence_reducer";
import StartTypingReducer from "./start_typing_reducer";
import StopTypingReducer from "./stop_typing_reducer";
import TransferOwnershipReducer from "./transfer_ownership_reducer";
import UnarchiveConversationReducer from "./unarchive_conversation_reducer";
import UnmuteConversationReducer from "./unmute_conversation_reducer";
import UnpinMessageReducer from "./unpin_message_reducer";
import UpdateGroupReducer from "./update_group_reducer";
import UpdateProfileReducer from "./update_profile_reducer";
import UpdateUsernameReducer from "./update_username_reducer";
import VerifyEmailAndRegisterReducer from "./verify_email_and_register_reducer";

// Import all procedure arg schemas

// Import all table schema definitions
import ConversationRow from "./conversation_table";
import ConversationParticipantRow from "./conversation_participant_table";
import EmailVerificationRow from "./email_verification_table";
import FileAttachmentRow from "./file_attachment_table";
import MessageRow from "./message_table";
import MessageReactionRow from "./message_reaction_table";
import NotificationRow from "./notification_table";
import ReadReceiptRow from "./read_receipt_table";
import TypingIndicatorRow from "./typing_indicator_table";
import UserRow from "./user_table";
import UserPresenceRow from "./user_presence_table";
import UserSessionRow from "./user_session_table";

/** Type-only namespace exports for generated type groups. */

/** The schema information for all tables in this module. This is defined the same was as the tables would have been defined in the server. */
const tablesSchema = __schema({
  conversation: __table({
    name: 'conversation',
    indexes: [
      { name: 'conversation_id', algorithm: 'btree', columns: [
        'conversationId',
      ] },
    ],
    constraints: [
      { name: 'conversation_conversation_id_key', constraint: 'unique', columns: ['conversationId'] },
    ],
  }, ConversationRow),
  conversation_participant: __table({
    name: 'conversation_participant',
    indexes: [
      { name: 'conversation_id', algorithm: 'btree', columns: [
        'conversationId',
      ] },
      { name: 'participant_id', algorithm: 'btree', columns: [
        'participantId',
      ] },
      { name: 'user_identity', algorithm: 'btree', columns: [
        'userIdentity',
      ] },
    ],
    constraints: [
      { name: 'conversation_participant_participant_id_key', constraint: 'unique', columns: ['participantId'] },
    ],
  }, ConversationParticipantRow),
  email_verification: __table({
    name: 'email_verification',
    indexes: [
      { name: 'email', algorithm: 'btree', columns: [
        'email',
      ] },
    ],
    constraints: [
      { name: 'email_verification_email_key', constraint: 'unique', columns: ['email'] },
    ],
  }, EmailVerificationRow),
  file_attachment: __table({
    name: 'file_attachment',
    indexes: [
      { name: 'attachment_id', algorithm: 'btree', columns: [
        'attachmentId',
      ] },
      { name: 'message_id', algorithm: 'btree', columns: [
        'messageId',
      ] },
    ],
    constraints: [
      { name: 'file_attachment_attachment_id_key', constraint: 'unique', columns: ['attachmentId'] },
    ],
  }, FileAttachmentRow),
  message: __table({
    name: 'message',
    indexes: [
      { name: 'conversation_id', algorithm: 'btree', columns: [
        'conversationId',
      ] },
      { name: 'message_id', algorithm: 'btree', columns: [
        'messageId',
      ] },
    ],
    constraints: [
      { name: 'message_message_id_key', constraint: 'unique', columns: ['messageId'] },
    ],
  }, MessageRow),
  message_reaction: __table({
    name: 'message_reaction',
    indexes: [
      { name: 'message_id', algorithm: 'btree', columns: [
        'messageId',
      ] },
      { name: 'reaction_id', algorithm: 'btree', columns: [
        'reactionId',
      ] },
    ],
    constraints: [
      { name: 'message_reaction_reaction_id_key', constraint: 'unique', columns: ['reactionId'] },
    ],
  }, MessageReactionRow),
  notification: __table({
    name: 'notification',
    indexes: [
      { name: 'notification_id', algorithm: 'btree', columns: [
        'notificationId',
      ] },
      { name: 'user_identity', algorithm: 'btree', columns: [
        'userIdentity',
      ] },
    ],
    constraints: [
      { name: 'notification_notification_id_key', constraint: 'unique', columns: ['notificationId'] },
    ],
  }, NotificationRow),
  read_receipt: __table({
    name: 'read_receipt',
    indexes: [
      { name: 'message_id', algorithm: 'btree', columns: [
        'messageId',
      ] },
      { name: 'receipt_id', algorithm: 'btree', columns: [
        'receiptId',
      ] },
      { name: 'user_identity', algorithm: 'btree', columns: [
        'userIdentity',
      ] },
    ],
    constraints: [
      { name: 'read_receipt_receipt_id_key', constraint: 'unique', columns: ['receiptId'] },
    ],
  }, ReadReceiptRow),
  typing_indicator: __table({
    name: 'typing_indicator',
    indexes: [
      { name: 'conversation_id', algorithm: 'btree', columns: [
        'conversationId',
      ] },
      { name: 'typing_id', algorithm: 'btree', columns: [
        'typingId',
      ] },
    ],
    constraints: [
      { name: 'typing_indicator_typing_id_key', constraint: 'unique', columns: ['typingId'] },
    ],
  }, TypingIndicatorRow),
  user: __table({
    name: 'user',
    indexes: [
      { name: 'email', algorithm: 'btree', columns: [
        'email',
      ] },
      { name: 'identity', algorithm: 'btree', columns: [
        'identity',
      ] },
      { name: 'user_id', algorithm: 'btree', columns: [
        'userId',
      ] },
    ],
    constraints: [
      { name: 'user_email_key', constraint: 'unique', columns: ['email'] },
      { name: 'user_identity_key', constraint: 'unique', columns: ['identity'] },
      { name: 'user_user_id_key', constraint: 'unique', columns: ['userId'] },
    ],
  }, UserRow),
  user_presence: __table({
    name: 'user_presence',
    indexes: [
      { name: 'user_identity', algorithm: 'btree', columns: [
        'userIdentity',
      ] },
    ],
    constraints: [
      { name: 'user_presence_user_identity_key', constraint: 'unique', columns: ['userIdentity'] },
    ],
  }, UserPresenceRow),
  user_session: __table({
    name: 'user_session',
    indexes: [
      { name: 'session_id', algorithm: 'btree', columns: [
        'sessionId',
      ] },
      { name: 'user_identity', algorithm: 'btree', columns: [
        'userIdentity',
      ] },
    ],
    constraints: [
      { name: 'user_session_session_id_key', constraint: 'unique', columns: ['sessionId'] },
    ],
  }, UserSessionRow),
});

/** The schema information for all reducers in this module. This is defined the same way as the reducers would have been defined in the server, except the body of the reducer is omitted in code generation. */
const reducersSchema = __reducers(
  __reducerSchema("add_attachment", AddAttachmentReducer),
  __reducerSchema("add_group_member", AddGroupMemberReducer),
  __reducerSchema("add_reaction", AddReactionReducer),
  __reducerSchema("archive_conversation", ArchiveConversationReducer),
  __reducerSchema("check_email_exists", CheckEmailExistsReducer),
  __reducerSchema("create_direct_conversation", CreateDirectConversationReducer),
  __reducerSchema("create_group_conversation", CreateGroupConversationReducer),
  __reducerSchema("create_notification", CreateNotificationReducer),
  __reducerSchema("delete_message", DeleteMessageReducer),
  __reducerSchema("delete_notification", DeleteNotificationReducer),
  __reducerSchema("demote_from_admin", DemoteFromAdminReducer),
  __reducerSchema("edit_message", EditMessageReducer),
  __reducerSchema("leave_conversation", LeaveConversationReducer),
  __reducerSchema("login_with_email", LoginWithEmailReducer),
  __reducerSchema("mark_all_notifications_read", MarkAllNotificationsReadReducer),
  __reducerSchema("mark_as_read", MarkAsReadReducer),
  __reducerSchema("mark_notification_read", MarkNotificationReadReducer),
  __reducerSchema("mute_conversation", MuteConversationReducer),
  __reducerSchema("pin_message", PinMessageReducer),
  __reducerSchema("promote_to_admin", PromoteToAdminReducer),
  __reducerSchema("register_user", RegisterUserReducer),
  __reducerSchema("remove_group_member", RemoveGroupMemberReducer),
  __reducerSchema("remove_reaction", RemoveReactionReducer),
  __reducerSchema("request_email_verification", RequestEmailVerificationReducer),
  __reducerSchema("send_message", SendMessageReducer),
  __reducerSchema("send_message_with_attachment", SendMessageWithAttachmentReducer),
  __reducerSchema("set_presence", SetPresenceReducer),
  __reducerSchema("start_typing", StartTypingReducer),
  __reducerSchema("stop_typing", StopTypingReducer),
  __reducerSchema("transfer_ownership", TransferOwnershipReducer),
  __reducerSchema("unarchive_conversation", UnarchiveConversationReducer),
  __reducerSchema("unmute_conversation", UnmuteConversationReducer),
  __reducerSchema("unpin_message", UnpinMessageReducer),
  __reducerSchema("update_group", UpdateGroupReducer),
  __reducerSchema("update_profile", UpdateProfileReducer),
  __reducerSchema("update_username", UpdateUsernameReducer),
  __reducerSchema("verify_email_and_register", VerifyEmailAndRegisterReducer),
);

/** The schema information for all procedures in this module. This is defined the same way as the procedures would have been defined in the server. */
const proceduresSchema = __procedures(
);

/** The remote SpacetimeDB module schema, both runtime and type information. */
const REMOTE_MODULE = {
  versionInfo: {
    cliVersion: "2.0.1" as const,
  },
  tables: tablesSchema.schemaType.tables,
  reducers: reducersSchema.reducersType.reducers,
  ...proceduresSchema,
} satisfies __RemoteModule<
  typeof tablesSchema.schemaType,
  typeof reducersSchema.reducersType,
  typeof proceduresSchema
>;

/** The tables available in this remote SpacetimeDB module. Each table reference doubles as a query builder. */
export const tables: __QueryBuilder<typeof tablesSchema.schemaType> = __makeQueryBuilder(tablesSchema.schemaType);

/** The reducers available in this remote SpacetimeDB module. */
export const reducers = __convertToAccessorMap(reducersSchema.reducersType.reducers);

/** The context type returned in callbacks for all possible events. */
export type EventContext = __EventContextInterface<typeof REMOTE_MODULE>;
/** The context type returned in callbacks for reducer events. */
export type ReducerEventContext = __ReducerEventContextInterface<typeof REMOTE_MODULE>;
/** The context type returned in callbacks for subscription events. */
export type SubscriptionEventContext = __SubscriptionEventContextInterface<typeof REMOTE_MODULE>;
/** The context type returned in callbacks for error events. */
export type ErrorContext = __ErrorContextInterface<typeof REMOTE_MODULE>;
/** The subscription handle type to manage active subscriptions created from a {@link SubscriptionBuilder}. */
export type SubscriptionHandle = __SubscriptionHandleImpl<typeof REMOTE_MODULE>;

/** Builder class to configure a new subscription to the remote SpacetimeDB instance. */
export class SubscriptionBuilder extends __SubscriptionBuilderImpl<typeof REMOTE_MODULE> {}

/** Builder class to configure a new database connection to the remote SpacetimeDB instance. */
export class DbConnectionBuilder extends __DbConnectionBuilder<DbConnection> {}

/** The typed database connection to manage connections to the remote SpacetimeDB instance. This class has type information specific to the generated module. */
export class DbConnection extends __DbConnectionImpl<typeof REMOTE_MODULE> {
  /** Creates a new {@link DbConnectionBuilder} to configure and connect to the remote SpacetimeDB instance. */
  static builder = (): DbConnectionBuilder => {
    return new DbConnectionBuilder(REMOTE_MODULE, (config: __DbConnectionConfig<typeof REMOTE_MODULE>) => new DbConnection(config));
  };

  /** Creates a new {@link SubscriptionBuilder} to configure a subscription to the remote SpacetimeDB instance. */
  override subscriptionBuilder = (): SubscriptionBuilder => {
    return new SubscriptionBuilder(this);
  };
}

